import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
import { DropdownItem } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import Dropdown from 'Components/Utility/Dropdown';
import DropdownMenu from 'Components/Utility/DropdownMenu';
import DropdownToggle from 'Components/Utility/DropdownToggle';
import ProductPrice from 'Components/Product/ProductCommerce/ProductPrice';
import usePreventScroll from 'Components/Hooks/usePreventScroll';

import 'Components/Product/ProductCommerce/MobileEditionSelector.scss';

const EditionDropDown = ({
  editions,
  productSlug,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const setScroll = usePreventScroll();

  useEffect(() => {
    if (isOpen) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  }, [isOpen, setScroll]);

  if (isEmpty(editions)) return false;
  const currentEdition = editions.find(edition => edition.slug === productSlug);
  if (!currentEdition) return false;
  const currentEditionName = get(currentEdition, 'edition_name', currentEdition.name).replace(' Edition', '');

  return (
    <Dropdown
      isOpen={isOpen}
      toggle={() => setIsOpen(!isOpen)}
      className="mobile-product-editions-dropdown-container"
    >
      <DropdownToggle
        className="product-editions-dropdown-toggle"
      >
        <div className="editions-dropdown-text">
          {currentEditionName}
        </div>
        <div className="icon">
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
      </DropdownToggle>

      <DropdownMenu>
        {editions.map((edition) => {
          const currentPrice = edition.currentPrice;
          const editionName = get(edition, 'edition_name', edition.name).replace(' Edition', '');

          return (
            <DropdownItem
              key={Math.random()}
              tag={Link}
              to={`/${edition.type}/${edition.slug}`}
              className="edition-container"
            >
              <div className={classNames('d-flex', productSlug === edition.slug && 'active-edition')}>
                <div
                  className={classNames('edition-content d-flex align-items-center', productSlug === edition.slug && 'active-item')}
                >
                  {editionName}
                </div>
                <div className="price-container d-flex align-items-center align-content-center ml-auto">
                  <strong>
                    <ProductPrice
                      price={currentPrice}
                      slug={edition.slug}
                      className={productSlug === edition.slug && 'price-active'}
                    />
                  </strong>
                </div>
              </div>
            </DropdownItem>
          );
        })}
      </DropdownMenu>
    </Dropdown>
  );
};

EditionDropDown.propTypes = {
  editions: PropTypes.arrayOf(PropTypes.shape({})),
  productSlug: PropTypes.string,
};

EditionDropDown.defaultProps = {
  editions: [],
  productSlug: '',
};


export default EditionDropDown;
